import { cn } from '@/common/lib/cn/cn'
import './card.css'

export type CardTopBorderColor = 'purple' | 'blue' | 'green' | 'orange'

export type GenerateCardProps = {
    color?: 'primary' | 'transparent'
    className?: string
    cardBodyClassName?: string
    /** Горизонтальный скролл таблицы внутри card-body, без раздувания карточки */
    tableScroll?: boolean
    type?: 'product' | 'result-first' | 'result-last' | 'result' | 'transparent'
    topBorderColor?: CardTopBorderColor
} & React.HTMLAttributes<HTMLDivElement>

export const Card = ({
    children,
    color = 'primary',
    className,
    cardBodyClassName,
    tableScroll = false,
    type = 'product',
    topBorderColor,
    ...props
}: GenerateCardProps) => {
    const cardClasses = cn(
        'card',
        {
            'bg-pixorion-dark-gray': color === 'primary',
            'bg-transparent': color === 'transparent',
            'card-product': type === 'product',
            'card-product-result': type === 'result',
            'card-product-result card-first': type === 'result-first',
            'card-product-result card-last': type === 'result-last',
            'card-transparent': type === 'transparent',
            'card-top-border-purple': topBorderColor === 'purple',
            'card-top-border-blue': topBorderColor === 'blue',
            'card-top-border-green': topBorderColor === 'green',
            'card-top-border-orange': topBorderColor === 'orange',
        },
        tableScroll && 'min-w-0 w-full',
        className
    )
    return (
        <div className={cardClasses} {...props}>
            {/* <figure>
                <img src='https://img.daisyui.com/images/stock/photo-1606107557195-0e29a4b5b4aa.webp' alt='Shoes' />
            </figure> */}
            <div className={cn('card-body', tableScroll && 'min-w-0 overflow-hidden', cardBodyClassName)}>
                {children}
            </div>
        </div>
    )
}
